package horcrux.common.api.dtos

import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.common.api.dtos.types.UserID
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.Serializable

@Serializable
class PostCollectionsRequest : HorcruxValidatedRequest

@Serializable
data class PostCollectionsResponse(val collectionMetadataList: List<CollectionMetadata>) : HorcruxResponse

open class PostCollectionsError(httpStatusCode: HttpStatusCode) : HorcruxRequestSimpleError(httpStatusCode)

data class ErrorRetrievingCollectionsFromDatabase(
    val userID: UserID,
    override val cause: Throwable,
) : PostCollectionsError(HttpStatusCode.BadGateway)
